/* eslint no-underscore-dangle: ["error", { "allow": ["_e"] }] */
let init = false;

function twitter() {
  if (init) {
    return window.twttr;
  }

  window.twttr = ((d, s, id) => {
    const fjs = d.getElementsByTagName(s)[0];
    const t = {};
    const js = d.createElement(s);
    js.id = id;
    js.src = 'https://platform.twitter.com/widgets.js';
    fjs.parentNode.insertBefore(js, fjs);

    t._e = [];
    t.ready = (f) => {
      t._e.push(f);
    };
    return t;
  })(document, 'script', 'twitter-wjs');

  init = true;
  return window.twttr;
}

export default twitter;



// WEBPACK FOOTER //
// ./src/components/twitter/twitter.js